import { render } from "./smsComponent.vue?vue&type=template&id=871a5ae0&scoped=true"
import script from "./smsComponent.vue?vue&type=script&lang=js"
export * from "./smsComponent.vue?vue&type=script&lang=js"

import "./smsComponent.vue?vue&type=style&index=0&id=871a5ae0&scoped=true&lang=css"
import "./smsComponent.vue?vue&type=style&index=1&id=871a5ae0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-871a5ae0"]])

export default __exports__